export enum PreferenceType {
	EMAIL = "EMAIL",
	SMS = "SMS",
	EMAIL_SMS = "EMAIL_SMS",
}
